import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

export const selectClientFolderId = (folderId) => {
  return {
    type: actionTypes.SELECT_CLIENT_FOLDER,
    folderId,
  };
};
export const selectUserId= (userId) => {
  return {
    type: actionTypes.SET_USER_ID,
    userId,
  };
};

export const fetchFoldersStart = () => {
  return {
    type: actionTypes.FETCH_USER_FOLDERS_START,
  };
};
export const fetchFoldersFail = (error) => {
  return {
    type: actionTypes.FETCH_USER_FOLDERS_FAIL,
    error,
  };
};
export const fetchFoldersSuccess = (folders, count) => {
  return {
    type: actionTypes.FETCH_USER_FOLDERS_SUCCESS,
    folders,
    count,
  };
};

export const fetchFoldersUserAdmin = (userId, pageN, pageS) => {
  return (dispatch) => {
    // console.log(userId);
    dispatch(fetchFoldersStart());
    axios
      .get(
        `admin/client/folder/${userId}?pageNumber=${pageN}&pageSize=${pageS}`
      )
      .then((res) => {
        console.log(res);
        dispatch(fetchFoldersSuccess(res.data.folders, res.data.total));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchFoldersFail(err.response.data.message));
        } else {
          dispatch(fetchFoldersFail("Something went wrong"));
        }
      });
  };
};

// create folder
// Create folder
export const createClientFolderStart = () => {
  return {
    type: actionTypes.CREATE_FOLDER_CLIENT_START,
  };
};
export const createClientFolderFail = (error) => {
  return {
    type: actionTypes.CREATE_FOLDER_CLIENT_FAIL,
    error,
  };
};
export const createClientFolderSuccess = (newfolder) => {
  return {
    type: actionTypes.CREATE_FOLDER_CLIENT_SUCCESS,
    newfolder,
  };
};

export const createClientFolder = (clientId, data ,callBack) => {
  return (dispatch) => {
    dispatch(createClientFolderStart());
    axios
      .post(`admin/client/folder/${clientId}`, data)
      .then((res) => {
        console.log(res.data.folder);
        dispatch(createClientFolderSuccess(res.data.folder));
      
        callBack();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(createClientFolderFail(err.response.data.message));
        } else {
          dispatch(createClientFolderFail("Something went wrong"));
        }
      });
  };
};

// DELETE folder
export const deleteFoldersStart = () => {
  return {
    type: actionTypes.DELETE_CLIENT_FOLDERS_START,
  };
};

export const deleteFoldersSuccess = (folderId) => {
  return {
    type: actionTypes.DELETE_CLIENT_FOLDERS_SUCCESS,
    folderId,
  };
};

export const deleteFoldersFail = (error) => {
  return {
    type: actionTypes.DELETE_CLIENT_FOLDERS_FAIL,
    error,
  };
};

export const deleteClientFolder = (folderId , userId) => {
  return (dispatch) => {
    dispatch(deleteFoldersStart());
    axios
      .delete(`super/client/folder/${folderId}`)
      .then((res) => {
        // console.log(res);
        // console.log(folderId);
        dispatch(deleteFoldersSuccess(folderId));
        dispatch(fetchFoldersUserAdmin(userId))
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(deleteFoldersFail(err.response.data.message));
        } else {
          dispatch(deleteFoldersFail("Something went wrong"));
        }
      });
  };
};

// Rename folder
export const renameFoldersStart = () => {
  return {
    type: actionTypes.RENAME_CLIENT_FOLDERS_START,
  };
};

export const renameFoldersSuccess = (folderId, name, msg) => {
  return {
    type: actionTypes.RENAME_CLIENT_FOLDERS_SUCCESS,
    folderId,
    name,
    msg,
  };
};

export const renameFoldersFail = (error) => {
  return {
    type: actionTypes.RENAME_CLIENT_FOLDERS_FAIL,
    error,
  };
};

export const renameClientFolder = (folderId, data , callBack) => {
  return (dispatch) => {
    dispatch(renameFoldersStart());
    axios
      .patch(`admin/client/folder/${folderId}`, data)
      .then((res) => {
        // console.log(res);
        // console.log(folderId);
        dispatch(renameFoldersSuccess(folderId, data.folderName, res.message));
        // dispatch(fetchFoldersUserAdmin(userId))
        callBack();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(renameFoldersFail(err.response.data.message));
        } else {
          dispatch(renameFoldersFail("Something went wrong"));
        }
      });
  };
};

export const clearMsgClientFolder = (folderId) => {
  return {
    type: actionTypes.CLEAR_MSG_CLIENT_FOLDER,
    folderId,
  };
};
